import { List } from "immutable";

import { makeGetNumberOfIncompleteAssignments } from "seneca-common/features/assignments/features/student-assignments/selectors/makeGetNumberOfIncompleteAssignmentsSections";
import { useMemoSelector } from "seneca-common/utils/hooks/selectors";

import useGetAssignmentIds from "./useGetAssignmentIds";

export default function useGetNumberOfUnstudiedAssignmentsForCourse() {
  const { assignmentIds } = useGetAssignmentIds();

  return useMemoSelector(
    makeGetNumberOfIncompleteAssignments,
    List(assignmentIds)
  );
}
